import { Reveal, SectionHead, Btn } from "../Bits";
import { COMPARISON_ROWS } from "../../lib/site";

const Compare = ({ products }) => {
  const mats = products.filter((p) => p.type === "mat");

  return (
    <section data-testid="home-compare" className="bg-white py-20 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <Reveal>
          <SectionHead
            eyebrow="Comparison"
            title="Find the right MAKO system"
            copy="A qualitative comparison of the three main mat systems. Exact specifications are confirmed during planning."
          />
        </Reveal>

      <div className="mt-6 flex items-center gap-3 lg:hidden">
        <span className="h-[1px] w-6 bg-[#0F4C81]" />
        <p className="mako-label text-[#7A7F85]">Swipe the table to compare</p>
      </div>

      <Reveal delay={0.1}>
          <div className="mt-6 overflow-x-auto lg:mt-20">
            <table
              data-testid="comparison-table"
              className="w-full min-w-[820px] border-collapse text-left"
            >
              <thead>
                <tr className="border-b border-[#111111]/15">
                  <th className="mako-label w-56 py-6 pr-8 align-bottom text-[#7A7F85]">
                    Compare
                  </th>
                  {mats.map((m) => (
                    <th key={m.slug} className="py-6 pr-8 align-bottom">
                      <span className="mako-label block text-[#0F4C81]">{m.label}</span>
                      <span className="mt-3 block font-display text-lg font-bold uppercase tracking-tight text-[#111111]">
                        {m.short_name}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COMPARISON_ROWS.map((row) => (
                  <tr
                    key={row.key}
                    className="border-b border-[#111111]/8 transition-colors duration-300 hover:bg-[#F5F5F2]"
                  >
                    <th className="mako-label py-6 pr-8 font-bold text-[#111111]">{row.label}</th>
                    {mats.map((m) => (
                      <td
                        key={m.slug + row.key}
                        className="py-6 pr-8 text-sm leading-relaxed text-[#3B3B3B]"
                      >
                        {m.comparison?.[row.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Btn to="/contact" data-testid="compare-help-cta">
              Help me choose
            </Btn>
            <p className="text-xs leading-relaxed text-[#7A7F85]">
              Thickness, density and dimensions are confirmed against the configuration selected for
              your facility.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Compare;
